"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// because react-widgets datepicker add postfix '_input' to the id
var _default = exports["default"] = function _default(id) {
  return "".concat(id, "_input");
};